import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.post.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-post-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.post.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalPostListComponent implements OnInit {
    public state: string = 'loading';
    public error: string = '';
    public list: any[] = [];
    public categories: string[] = [];
    public selectedCategory: string = '';
    public search: any = { text: '', page: 1, dump: 20 };
    public pagination: any = { end: 0, start: 0, current: 1 };
    private keyupTime: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadCategories();
        await this.load();
    }

    public async loadCategories() {
        const { code, data } = await wiz.call('categories');
        this.categories = code === 200 ? (data || []) : [];
    }

    public async selectCategory(category: string) {
        this.selectedCategory = this.selectedCategory === category ? '' : category;
        await this.load(1);
    }

    public searchAction() {
        this.keyupTime = Date.now();
        const reference = this.keyupTime;
        setTimeout(async () => {
            if (reference === this.keyupTime) await this.load(1);
        }, 300);
    }

    public async load(page: number = 1) {
        this.state = 'loading';
        this.error = '';
        this.search.page = page;
        this.pagination.current = page;
        await this.service.render();
        const { code, data } = await wiz.call('search', {
            ...this.search,
            category: this.selectedCategory
        });
        if (code === 200) {
            this.list = data.rows || [];
            const total = data.total || 0;
            this.pagination.start = total > 0 ? 1 : 0;
            this.pagination.end = Math.ceil(total / this.search.dump);
            this.state = this.list.length ? 'ready' : 'empty';
        } else {
            this.list = [];
            this.error = data?.message || data || '게시물을 불러오지 못했습니다.';
            this.state = 'error';
        }
        await this.service.render();
    }

    public statusClass(status: string) {
        if (status === 'published') return 'bg-green-50 text-green-700 border border-green-200';
        if (status === 'draft') return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
        return 'bg-gray-50 text-gray-600 border border-gray-200';
    }
}

export default PortalPostListComponent;